export default {
        all_items: [],
        item_categories: [],
        items: [],
        item_types: [],
        item_uom: [],
        item_brand: [],
        item_size: [],
        all_bundles: [],
        item_edit_info: [],
        store_item: [],
        store_import_item: [],
        update_import_item: [],
        store_import_image: [],
        show_item: [],
        update_selected_item: [],
        destroy_item: [],
        store_item_bundle: [],
        item_bundle: [],
        update_item_bundle: [],
        destroy_item_bundle: [],
        all_item_types: [],
        store_item_types: [],
        show_item_types: [],
        update_item_types: [],
        destroy_item_types: [],
        all_item_categories: [],
        store_item_categories: [],
        show_item_categories: [],
        update_item_categories: [],
        destroy_item_categories: [],
        all_item_uom: [],
        store_item_uom: [],
        show_item_uom: [],
        update_item_uom: [],
        destroy_item_uom: [],
        all_item_brand: [],
        store_item_brand: [],
        show_item_brand: [],
        update_item_brand: [],
        destroy_item_brand: [],
        all_item_sizes: [],
        store_item_sizes: [],
        show_item_sizes: [],
        update_item_sizes: [],
        destroy_item_sizes: [],
        warehouse_item_stocks: [],
        post_warehouse_item_stocks: [],
        item_substitution: [],
        exportItemModal: false,
        importItemModal: false,
        export_item_master_to_excel: [],
        item_template: [],
        item_template_selection: [],
        item_template_details: [],
        test: '',
        is_sp:false,
        parts_compatibility: [],
    };
